import { render, staticRenderFns } from "./MenuUpsells.vue?vue&type=template&id=33604a54"
import script from "./MenuUpsells.vue?vue&type=script&lang=ts"
export * from "./MenuUpsells.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports